import React from 'react';

// For accessibility we render a skip to main content button as the first focusable element
// Satisfies WCAG 2.4.1
// https://www.w3.org/WAI/WCAG21/Understanding/bypass-blocks.html
const SkipToContent = () => {
    return (
        <a className="button primary skip-to-content" href="#main-content">
            Skip to content
        </a>
    );
};

export default SkipToContent;
